export default "__VITE_ASSET__xrm2r0TU__"